export type UserStatus = 'all' | 'active' | 'passive';

export default function UserStatusFilter({ value, onChange, total, active }: {
  value: UserStatus;
  onChange: (value: UserStatus) => void;
  total: number;
  active: number;
}) {
  const options = [
    { value: 'all', label: 'Tümü', count: total },
    { value: 'active', label: 'Aktif', count: active },
    { value: 'passive', label: 'Pasif', count: total - active },
  ] as const;
  return (
    <div role="group" aria-label="Kullanıcı durumu" className="flex items-center gap-1 rounded-lg border border-slate-200 bg-slate-50 p-1">
      {options.map(option => (
        <button key={option.value} type="button" aria-pressed={value === option.value} onClick={() => onChange(option.value)}
          className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-semibold transition ${value === option.value ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-600 hover:bg-white'}`}>
          {option.label}<span className={`rounded px-1 text-[10px] tabular-nums ${value === option.value ? 'bg-white/20' : 'bg-slate-200/60 text-slate-500'}`}>{option.count}</span>
        </button>
      ))}
    </div>
  );
}
